// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7-34l","placeholdersHeader":"styles_placeholdersHeader__1W57h","editorStyle":"styles_editorStyle__3Sdy1","placeholdersBox":"styles_placeholdersBox__3zsUV"};